import React, { Component } from 'react'
import Included from '../Included'
class Cards extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
      <section><a className="anchor" id="cards"></a>
        <h2>Cards</h2>

        <h3>Basic Card</h3>

        <p>To create a basic card, add a class of <code className="inline">card</code> to any block-level element. Each card can contain an optional <code className="inline">card__header</code> and an optional <code className="inline">card__body</code>. By default, each card will consume 100% of the width of its container, therefore a single card implemented within a full width container will render as follows:</p>

        <div className="card">
          <div className="card__header">
            <span className="card__header-title">Card Header Title</span>
          </div>
          <div className="card__body">
            <p>The default card implementation has no pre-defined styles for the body of the card (with the exception of padding), to allow the user to define their own content styles.</p>
          </div>
        </div>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="card">
  <div class="card__header">
    <span class="card__header-title">Card Header Title</span>
  </div>
  <div class="card__body">
    <p>The default card implementation has no pre-defined styles for the body of the card (with the exception of padding), to allow the user to define their own content styles.</p>
  </div>
</div>`}</code></pre>

        <p>Optionally, the card header can also contain a &quot;pre-title&quot; element immediately before the title in the header by creating an element with a class of <code className="inline">card__header-pre-title</code>. This could be used, for example, to denote status and/or context via an icon and/or background color.</p>

        <div className="card">
          <div className="card__header">
            <span className="card__header-pre-title"><i className="fa fa-bar-chart"></i></span>
            <span className="card__header-title">Card Header Title</span>
          </div>
          <div className="card__body">
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
          </div>
        </div>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="card">
  <div class="card__header">
    <span class="card__header-pre-title"><i class="fa fa-bar-chart"></i></span>
    <span class="card__header-title">Card Header Title</span>
  </div>
  <div class="card__body">
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
  </div>
</div>`}</code></pre>

        <h3>Grid Layout</h3>

        <p>To render multiple cards in a responsive grid, use the <a href="#grid">grid</a> layout to wrap each card. <strong>Note:</strong> Some of the styling implemented in the example below is purely for demonstration purposes only and therefore is not included in the main Common UI library.</p>

        <select className="size-select">
          <option value="auto">Select a resolution</option>
          <option value="482">480px (xs)</option>
          <option value="770">768px (sm)</option>
          <option value="994">992px (md)</option>
          <option value="1202">1200px (lg)</option>
          <option value="1602">1600px (xlg)</option>
        </select>
        <br/><br/>
        <div className="iframe-container" style={{"height":"716px"}}>
          <iframe seamless srcDoc={`
          <html>
            <head>
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              <link rel="stylesheet" type="text/css" href="css/styleguide.css">
            </head>
            <body>

              <div class="grid">

                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">

                  <div class="card">
                    <div class="card__header">
                      <span class="card__header-pre-title card__header-pre-title--positive card__header-pre-title--new"></span>
                      <span class="card__header-title">Active</span>
                      <span class="card__header-meta">01/11/16 – 12/31/16</span>
                    </div>
                    <div class="card__body">
                      <div class="card__content">
                        <a class="card__body-title">Ultra 10-Year Futures Market Maker Program</a>
                        <ul class="push--ends">
                          <li>Type: <strong>Futures</strong></li>
                          <li>Asset Class: <strong>Interest Rates</strong></li>
                          <li>Exchange: <strong>CBOT</strong></li>
                        </ul>
                      </div>
                      <div class="card__actions">
                        <div class="push--bottom">
                          <a>View Program Accounts</a>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">

                  <div class="card">
                    <div class="card__header">
                      <span class="card__header-pre-title card__header-pre-title--warning"></span>
                      <span class="card__header-title">Upcoming</span>
                      <span class="card__header-meta">01/01/16 – 12/31/16</span>
                    </div>
                    <div class="card__body">
                      <div class="card__content">
                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>
                        <p class="card__body-subtitle">Program Details Not Available</p>
                        <ul class="meta-list push--ends">
                          <li>Type: <strong>Futures</strong></li>
                          <li>Asset Class: <strong>Agricultural</strong></li>
                          <li>Exchange: <strong>CBOT</strong></li>
                        </ul>
                      </div>
                      <div class="card__actions">
                        <div class="push--bottom">
                          <a>View Program Accounts</a>
                        </div>
                        <button class="btn card__action">Renew Program</button>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">

                  <div class="card">
                    <div class="card__header">
                      <span class="card__header-pre-title card__header-pre-title--default"></span>
                      <span class="card__header-title">Expired</span>
                      <span class="card__header-meta">01/01/16 – 12/31/16</span>
                    </div>
                    <div class="card__body">
                      <div class="card__content">
                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>
                        <p class="card__body-subtitle">Program Details Not Available</p>
                        <ul class="meta-list push--ends">
                          <li>Type: <strong>Futures</strong></li>
                          <li>Asset Class: <strong>Agricultural</strong></li>
                          <li>Exchange: <strong>CBOT</strong></li>
                        </ul>
                      </div>
                      <div class="card__actions">
                        <div class="push--bottom">
                          <a>View Program Accounts</a>
                        </div>
                        <button class="btn card__action">Renew Program</button>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">

                  <div class="card">
                    <div class="card__header">
                      <span class="card__header-pre-title card__header-pre-title--warning"></span>
                      <span class="card__header-title">Upcoming</span>
                      <span class="card__header-meta">01/01/16 – 12/31/16</span>
                    </div>
                    <div class="card__body">
                      <div class="card__content">
                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>
                        <p class="card__body-subtitle">Program Details Not Available</p>
                        <ul class="meta-list push--ends">
                          <li>Type: <strong>Futures</strong></li>
                          <li>Asset Class: <strong>Agricultural</strong></li>
                          <li>Exchange: <strong>CBOT</strong></li>
                        </ul>
                      </div>
                      <div class="card__actions">
                        <div class="push--bottom">
                          <a>View Program Accounts</a>
                        </div>
                        <button class="btn card__action">Renew Program</button>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">

                  <div class="card">
                    <div class="card__header">
                      <span class="card__header-pre-title card__header-pre-title--default"></span>
                      <span class="card__header-title">Expired</span>
                      <span class="card__header-meta">01/01/16 – 12/31/16</span>
                    </div>
                    <div class="card__body">
                      <div class="card__content">
                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>
                        <p class="card__body-subtitle">Program Details Not Available</p>
                        <ul class="meta-list push--ends">
                          <li>Type: <strong>Futures</strong></li>
                          <li>Asset Class: <strong>Agricultural</strong></li>
                          <li>Exchange: <strong>CBOT</strong></li>
                        </ul>
                      </div>
                      <div class="card__actions">
                        <div class="push--bottom">
                          <a>View Program Accounts</a>
                        </div>
                        <button class="btn card__action">Renew Program</button>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">

                  <div class="card">
                    <div class="card__header">
                      <span class="card__header-pre-title card__header-pre-title--warning"></span>
                      <span class="card__header-title">Upcoming</span>
                      <span class="card__header-meta">01/01/16 – 12/31/16</span>
                    </div>
                    <div class="card__body">
                      <div class="card__content">
                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>
                        <p class="card__body-subtitle">Program Details Not Available</p>
                        <ul class="meta-list push--ends">
                          <li>Type: <strong>Futures</strong></li>
                          <li>Asset Class: <strong>Agricultural</strong></li>
                          <li>Exchange: <strong>CBOT</strong></li>
                        </ul>
                      </div>
                      <div class="card__actions">
                        <div class="push--bottom">
                          <a>View Program Accounts</a>
                        </div>
                        <button class="btn card__action">Renew Program</button>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </body>
          </html>
        `}></iframe>
        </div>

        <br/>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
        <pre className="hide-code"><code className="language-html">{`<div class="grid">

  <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">
    <div class="card">
      <!-- card content -->
    </div>
  </div>

  <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">
    <div class="card">
      <!-- card content -->
    </div>
  </div>

  ...

  <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">
    <div class="card">
      <!-- card content -->
    </div>
  </div>

</div>`}</code></pre>

        <br/>
        <hr/>
      </section>
    )
  }
}
export default Cards



// WEBPACK FOOTER //
// ./styleguide/components/sections/Cards.js